// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Icon, { IconWrapper } from "@insite/mobius/Icon";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { hasIcon } from "@store/Framework/Common/Hooks/IconIndex/iconResolver"; // Store Custom Code
import { ProductAvailabilityStyles } from "@store/Overrides/Components/ProductAvailability";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { iconScalableStyles } from "@toolkit/Themes/common/mixins";
import React from "react";
import { css } from "styled-components";

interface CustomColorAvailabilityProps {
    messageColor: string;
    messageIcon: string | undefined;
    extendedStyles?: ProductAvailabilityStyles;
    message: string;
}

const getStatusStyles = (color: string, hasIcon?: boolean) => {
    return {
        css: css`
            margin: 0;

            position: relative;
            ${hasIcon &&
            `
                display: flex;
                align-items: center;
                gap: ${pxToRem(2)};
            `}
            ${({ theme }) => css`
                color: ${getColor(color)};
                font-size: ${theme.design.typography.size.smaller};
                font-weight: ${theme.design.typography.weight.bold};
            `}

            ${IconWrapper} {
                ${iconScalableStyles(pxToRem(20))}

                color: ${getColor(color)};
            }
        `,
    };
};
const ProductStatusMessage: React.FC<CustomColorAvailabilityProps> = ({
    extendedStyles,
    messageColor,
    messageIcon,
    message,
}) => {
    const showIcon = !!messageIcon && hasIcon(messageIcon); // Store Custom Code
    const wrapperStyle = getStatusStyles(messageColor ?? "", showIcon);
    const extendedWrapperStyles = {
        css: css`
            ${wrapperStyle.css};
            ${extendedStyles?.inventoryMessage?.css};
        `,
    };

    return (
        <StyledWrapper {...extendedWrapperStyles}>
            {showIcon && <Icon src={messageIcon} />}
            <Typography data-test-selector="availabilityMessage">{message}</Typography>
        </StyledWrapper>
    );
};

export default ProductStatusMessage;
